export const updateModel = `mutation ($model: UpdateModelRequest!){
    updateModel(input: $model)
    }`;
    